// HowItWorksSection - Progressive carousel walkthrough of the Gitcha platform
import { helpURL } from "../../constants/endPoints";
import heroSearchMarket from "../../images/hero-search-market.jpg";
import heroBuyerIntent from "../../images/hero-buyer-intent.jpg";
import heroIntroduction from "../../images/hero-introduction.jpg";
import {
  ProgressSlider,
  SliderContent,
  SliderWrapper,
  SliderBtnGroup,
  SliderBtn,
} from "./ProgressiveCarousel";

const steps = [
  {
    img: heroSearchMarket,
    title: "Search Your Market",
    desc: "Enter a city or ZIP code to see real-time buyer demand in your area.",
    sliderName: "search",
  },
  {
    img: heroBuyerIntent,
    title: "Discover Buyer Demand",
    desc: "See exactly what buyers want: must-haves, nice-to-haves, timeline, financing, and more.",
    sliderName: "discover",
  },
  {
    img: heroIntroduction,
    title: "Make the Introduction",
    desc: "Send your property and communicate with licensed professionals representing qualified buyers.",
    sliderName: "introduce",
  },
];

const HowItWorksSection = () => {
  return (
    <section className="how-it-works">
      <h2 className="how-it-works__heading">How Gitcha Works</h2>
      <div className="how-it-works__carousel">
        <ProgressSlider vertical={false} activeSlider="search">
          <SliderContent>
            {steps.map((step, index) => (
              <SliderWrapper key={index} value={step.sliderName}>
                <img
                  className="prog-carousel__image"
                  src={step.img}
                  alt={step.desc}
                />
              </SliderWrapper>
            ))}
          </SliderContent>

          <SliderBtnGroup>
            {steps.map((step, index) => (
              <SliderBtn key={index} value={step.sliderName}>
                <h3 className="prog-carousel__step-title">{step.title}</h3>
                <p className="prog-carousel__step-desc">{step.desc}</p>
              </SliderBtn>
            ))}
          </SliderBtnGroup>
        </ProgressSlider>
      </div>
      <a
        href={helpURL}
        target="_blank"
        rel="noopener noreferrer"
        className="how-it-works__link"
      >
        View tutorials & learn more
      </a>
    </section>
  );
};

export default HowItWorksSection;
